// extracted by mini-css-extract-plugin
module.exports = {"roleDisabled":"RoleProtectedLink_roleDisabled__utoDc"};